import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import React, { FC, useState, useEffect } from 'react';
import { PageLayout } from '../../components/core/PageLayout/PageLayout';
import PrimaryNavigation from '../../components/core//PrimaryNavigation/PrimaryNavigation';
import { loginRequest } from '../../authConfig';
import { callMsGraph } from '../../graph';
import { ProfileData } from '../../components/core/ProfileData/ProfileData';
import { fetchUserMySelf } from '../../redux/slices/UsersSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/store';
import { IResult, IGroup, IPermission, IPolicy, IUserType } from '../../types/Users';
import { Link, useNavigate } from 'react-router-dom';
import './Home.css';
import HomeCards from '../../components/core/Home-Cards/Home-Cards';
import Swal from 'sweetalert2'
import AlertHome from '../../components/core/Alert-Home/Alert-Home';
import Spinner from '../../components/Spinner/Spinner';
import ErrorPage from '../ErrorPages/ErrorPage';
import CryptoJS from 'crypto-js';
import BannerWelcome from '../../components/core/BannerWelcome/BannerWelcome';
import BannerHome from '../../components/core/BannerHome/BannerHome';
import Footer from '../../components/core/Footer/Footer';
import { Console } from 'console';
import {REDIRECT_URI, BASE_URL_ENDPOINT, AZURE_ID, AZURE_TENANT_ID, SITE_URI} from '../../config/env';
import { createUriPath } from "../../Helpers/path-uri";

interface ProfileContentProps {
  onProfileContentLoaded: () => void;
}
const ProfileContent: React.FC<ProfileContentProps> = ({ onProfileContentLoaded }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const result = useAppSelector(state => state.UsersSlice.result);
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [reloadPage, setReloadPage] = useState(true);
  const [refreshed, setRefreshed] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(true);
  const [profileDataLoaded, setProfileDataLoaded] = useState(false);

  useEffect(() => {
    console.log(`*1REDIRECT_URI: ${REDIRECT_URI}`);
    console.log(`*2BASE_URL_ENDPOINT: ${BASE_URL_ENDPOINT}`);
    // console.log(`*3AZURE_ID: ${AZURE_ID}`);
    // console.log(`*4AZURE_TENANT_ID: ${AZURE_TENANT_ID}`);
    const fetchData = async () => {
      try {
        setProfileDataLoaded(true);
        onProfileContentLoaded();
        setProfileDataLoaded(false);
        setLoading(true)
        await getAPI();
        setProfileDataLoaded(true);
        setLoading(false)
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  interface GlobalData {
    groupId: string;
    groupName: string;
    groupIsRepositoryOwner: boolean;
    groupAllowedRepository: string;
    policyName: string;
    permissionModule: string;
    permissionScopes: Array<string>;
  }

  const globalData: GlobalData = {
    groupId: "",
    groupName: "",
    groupIsRepositoryOwner: false,
    groupAllowedRepository: "",
    policyName: "",
    permissionModule: "",
    permissionScopes: []
  };

async function getAPI() {
  try {
      
      await RequestProfileData();
      CheckSessionStorage();
  } catch (error) {
    showErrorModal(error);
  }
}

function CheckSessionStorage(){
  const storedUrl = sessionStorage.getItem('currentUrl');
    if (storedUrl) {
      console.log('============ REDIRECT LOG: [Home] - Navigate to storedUrl', storedUrl);
      // console.log(createUriPath(storedUrl));
      console.log("retrocediendo -2...");
      navigate(-2);
      sessionStorage.removeItem('currentUrl');
    }
    return null;
}

  function RequestProfileData() {
    return new Promise((resolve, reject) => {
      instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        const idToken = response.idToken;
        const accessToken = response.accessToken;
        // sessionStorage.setItem('idToken', idToken);
        // sessionStorage.setItem('accessToken', accessToken);
        sessionStorage.setItem('idToken', idToken);
        sessionStorage.setItem('accessToken', accessToken);
        console.log("version: 0.1.5");
        console.log("accessToken:", accessToken);
        console.log("idToken:", idToken);
        callMsGraph(accessToken)
          .then((response) => {
            setGraphData(response);
            dispatch(fetchUserMySelf({ token: idToken})).then(result => {
              const resultado = result.payload;
              GetProfileById(resultado);
              
    return null;
            });
          })
          .then(r => resolve('Se guardo el token en el store'))
          .catch((error) => {
            reject();
            console.log('Error al llamar a callMsGraph:', error);
          });
      })
      .catch((error) => {
        console.log('Error adquiriendo token:', error);
      });
    });
    
  }

  const GetProfileById = (resultado:any) => {
    if (resultado && resultado.groups) {
      console.log("resultado:", resultado);
      resultado.groups.forEach((group: any, groupIndex: number) => {
        // console.log("resultado:", resultado);
        const { email, idpId, name, userId, userType } = resultado;
        const { id: userTypeId, value: userTypeValue } = userType;
        const groups: IGroup[] = resultado.groups;
        globalData.groupId = group.id || "";
        globalData.groupName = group.name || "";
        globalData.groupIsRepositoryOwner = group.isRepositoryOwner || false;
        globalData.groupAllowedRepository = group.allowedRepository || "";
        globalData.policyName = group.policies[0].name || "";
        globalData.permissionModule = group.policies[0].permissions[0].module || "";
        globalData.permissionScopes = group.policies[0].permissions[0].scopes || [];
        sessionStorage.setItem('email', email);
        sessionStorage.setItem('idpId', idpId);
        sessionStorage.setItem('name', name);
        sessionStorage.setItem('userId', JSON.stringify(userId));
        sessionStorage.setItem('userType-Id', userTypeId.toString());
        sessionStorage.setItem('usertype-Value', userTypeValue);
        sessionStorage.setItem('groupId', globalData.groupId);
        sessionStorage.setItem('groupName', globalData.groupName);
        sessionStorage.setItem('groupIsRepositoryOwner', globalData.groupIsRepositoryOwner.toString());
        sessionStorage.setItem('groupAllowedRepository', globalData.groupAllowedRepository);
        sessionStorage.setItem('policyName', globalData.policyName);
        sessionStorage.setItem('permissionModule', globalData.permissionModule);
        sessionStorage.setItem('permissionScopes', JSON.stringify(globalData.permissionScopes));
            
        // console.log("email: ", email);
        // console.log("idpId: ", idpId);
        // console.log("name: ", name);
        // console.log("userId: ", JSON.stringify(userId));
        // console.log("userTypeId: ", userTypeId.toString());
        // console.log("userTypeValue: ", userTypeValue);
        // console.log("groupId: ", globalData.groupId);
        // console.log("groupName: ", globalData.groupName);
        // console.log("groupIsRepositoryOwner: ", globalData.groupIsRepositoryOwner.toString());
        // console.log("groupAllowedRepository: ", globalData.groupAllowedRepository);
        // console.log("policyName: ", globalData.policyName);
        // console.log("permissionModule: ", globalData.permissionModule);
        //     console.log("permissionScopes: ", JSON.stringify(globalData.permissionScopes));
            const allowedRepositories: string[] = [];
            groups.forEach((group: IGroup, index: number) => {
              const groupObjectString = JSON.stringify(group);
              if (groupObjectString) {
                const groupObject: IGroup = JSON.parse(groupObjectString);
                group.policies.forEach((policy: IPolicy, policyIndex: number) => {
                  policy.permissions.forEach((permission: IPermission, permissionIndex: number) => {
                    const permissionModule = permission.module;
                    const permissionScopes = permission.scopes;
                    sessionStorage.setItem(`group-${groupIndex}-policy-${policyIndex}-permission-${permissionIndex}-module`, permissionModule);
                    sessionStorage.setItem(`group-${groupIndex}-policy-${policyIndex}-permission-${permissionIndex}-scopes`, JSON.stringify(permissionScopes));
                  });
                });
                const scopes = groupObject.policies.map((policy: IPolicy) => {
                  return policy.permissions.map((permission: IPermission) => permission.scopes);
                });
                const allowedRepository = groupObject.allowedRepository;
                allowedRepositories.push(allowedRepository);
                sessionStorage.setItem(`group-${index}`, JSON.stringify(groupObject));
                sessionStorage.setItem(`scopes-${index}`, JSON.stringify(scopes));
              } else {
               console.log("Se guardaron los datos del usuario en sessionStorage");
              }
            })
            sessionStorage.setItem("allowedRepositories", JSON.stringify(allowedRepositories));
            setLoading(false);
            setProfileDataLoaded(true);
            // sessionStorage.removeItem('currentUrl');
          })
        } else {
          console.log("ocurrio un error al almacenar los datos en session");
        }
        
        // console.log("no existe la storedurl");
      };

  const name:any = accounts[0] && accounts[0].name;
  sessionStorage.setItem('userName', name);
  const username = sessionStorage.getItem('userName');



  function showErrorModal(error: any) {
    const errorMessage = error.message;
    const modal = document.createElement('div');
    modal.classList.add('modal');
  
    const modalContent = document.createElement('div');
    modalContent.classList.add('modal-content');
  
    const closeButton = document.createElement('span');
    closeButton.classList.add('close');
    closeButton.innerHTML = '&times;';
    closeButton.onclick = () => {
      document.body.removeChild(modal);
    };
  
    const errorText = document.createElement('p');
    errorText.textContent = errorMessage;
  
    modalContent.appendChild(closeButton);
    modalContent.appendChild(errorText);
  
    modal.appendChild(modalContent);
  
    document.body.appendChild(modal);
  }
  // console.log("loading :", loading);
  return (
    <>
      {loading ? (
        <Spinner/>
      ) : (
        <>
        {graphData && <ProfileData graphData={graphData} />}
        <BannerWelcome username={username ? String(username) : ""} />
        {profileDataLoaded && <HomeCards />}
      </>
      )}
    </>
  );
};


const MainContent = () => {
  const [isProfileContentLoaded, setIsProfileContentLoaded] = useState(false);
  const handleProfileContentLoaded = () => {
    setIsProfileContentLoaded(true);
  };
  return (
    <main>
    <div className="body">
      <AuthenticatedTemplate>
      <ProfileContent onProfileContentLoaded={handleProfileContentLoaded} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate/>
      <div className="container-home">
      {!isProfileContentLoaded && (
      <BannerHome/>
)}
      </div>
    <Footer/>
    </div>
    </main>
    
   

  );
};
export default function Home() {
  
  
  
  useEffect



  return (
    
    <PageLayout>
       
       
        <MainContent />
        
  
      
    </PageLayout>
  );
}
